// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3DEAE","colMaxWidth":"Table_colMaxWidth__3zvEg"};